import React from 'react';
import styled from 'styled-components';

const DAYS = ['L', 'M', 'M', 'J', 'V', 'S', 'D'];

interface DaySelectorProps {
    selectedDays: boolean[];
    onDaySelect: (index: number) => void;
}

export const DaySelector: React.FC<DaySelectorProps> = ({ selectedDays, onDaySelect }) => {
    return (
        <Container>
            {selectedDays.map((selected, dayIndex) => (
                <DayContainer key={dayIndex}>
                    <DayLabel>{DAYS[dayIndex]}</DayLabel>
                    <Checkbox checked={selected} onChange={() => onDaySelect(dayIndex)} />
                </DayContainer>
            ))}
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    gap: 8px;
`;

const DayContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
`;

const DayLabel = styled.div`
    font-size: 12px;
    font-weight: 500;
`;

const Checkbox = styled.input.attrs({ type: 'checkbox' })`
    cursor: pointer;
    width: 16px;
    height: 16px;
`;
